module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAADeBAMAAACAiT48AAAAFVBMVEUAAAD///////////////////////9Iz20EAAAABnRSTlMA5+J9fnw8AgeBAAAAUElEQVRYw+3SsQ0AIAzEwFTUjJDdgN9/BHqU75Hia906tKIkhbZN6EAnSkN2m8EbPSj9G8kbrfEGHE3/xuSN1ngDvAHeAG/gwRtweAPOH29cY4IXgK0ygyUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/draw/scale.png
// module id = 17kT
// module chunks = 1